var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecreasingVolume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 31h-3v6h3zM30.5 29h-3v8h3zM24.5 25h-3v12h3zM18.5 19h-3v18h3zM12.5 11h-3v26h3zM6.5 3h-3v34h3z"
  })));
}
export default SvgDecreasingVolume;